import { render, staticRenderFns } from "./home_offer.vue?vue&type=template&id=89d5af86&scoped=true"
import script from "./home_offer.vue?vue&type=script&lang=js"
export * from "./home_offer.vue?vue&type=script&lang=js"
import style0 from "./home_offer.vue?vue&type=style&index=0&id=89d5af86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d5af86",
  null
  
)

export default component.exports